
<app-add-inventaire [bonTransfert]="true"
                    [entrpotInit]="true"
></app-add-inventaire>
